<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="600px" scrollable>
    <v-card>
      <v-card-title>
        <span class="text-h5">設定權限 - {{ accountName }}</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text style="max-height: 500px;">
        <AccountPermissionSelector
          v-model="selectedPermissions"
          :availablePermissions="availablePermissions"
          @open-page="handleOpenPage"
        />
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('input', false)">
          取消
        </v-btn>
        <v-btn
          color="teal"
          dark
          @click="handleSubmit"
        >
          送出
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import AccountPermissionSelector from './AccountPermissionSelector.vue'

/**
 * AccountPermissionsDialog - 編輯權限 Dialog
 *
 * Props:
 * - value: Dialog 開關狀態（v-model）
 * - account: 要編輯的帳號物件
 * - availablePermissions: 可用權限列表
 *
 * Events:
 * - input: Dialog 開關變更
 * - submit: 提交表單
 */
export default {
  name: 'AccountPermissionsDialog',
  components: {
    AccountPermissionSelector
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    account: {
      type: Object,
      default: null
    },
    availablePermissions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedPermissions: []
    }
  },
  computed: {
    accountName() {
      return this.account ? this.account.name : ''
    }
  },
  watch: {
    // 當 Dialog 打開時，載入帳號的現有權限
    value(newVal) {
      if (newVal && this.account) {
        this.selectedPermissions = [...this.account.route_permissions]
      }
    }
  },
  methods: {
    handleOpenPage(permissionCode) {
      const route = this.$router.resolve({ name: permissionCode })
      if (route && route.href) {
        window.open(route.href, '_blank')
      }
    },
    handleSubmit() {
      this.$emit('submit', {
        id: this.account.id,
        permissions: this.selectedPermissions
      })
    }
  }
}
</script>
